import React from 'react';
import { find } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useMutation } from '@apollo/client';
import { devices } from '../../constants.json';
import { Dropdown } from './inputControls';
import { CLIENT_STATE, SET_CLIENT_STATE } from '../../graphqls';

export default function DeviceBar() {
  const { loading, data: clientState = {} } = useQuery(CLIENT_STATE);
  const [setDeviceName] = useMutation(SET_CLIENT_STATE);

  if (loading) {
    return '';
  }

  const { deviceView } = clientState;
  const onSwitch = ({
    currentTarget: {
      dataset: { name },
    },
  }) => setDeviceName({ variables: { deviceView: name } });
  const { label, icon } = find(devices, ['name', deviceView]);

  return (
    <div className="device-settings">
      <Dropdown
        defaultValue={(
          <div className="device-selected">
            <FontAwesomeIcon icon={['fal', icon]} />
            <span>{label}</span>
          </div>
        )}
        customClass="device-setting-btn"
      >
        {devices.map(({ name, icon: deviceIcon, label: deviceLabel }) => (
          <button type="button" className="hollow-btn" key={name} data-name={name} onClick={onSwitch}>
            <FontAwesomeIcon icon={['fal', deviceIcon]} />
            <span>{deviceLabel}</span>
          </button>
        ))}
      </Dropdown>
    </div>
  );
}
